import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import gql from 'graphql-tag';
var RemoveItemFromBasket = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  mutation RemoveItems($input: [RemoveItemInput!]!, $basketId: ID!) {\n    removeItems(input: $input, basketId: $basketId)\n  }\n"])));
export default RemoveItemFromBasket;